import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const TimerIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 1.648C5.914 1.232 6.93 1 8 1C12.004 1 15.25 4.246 15.25 8.25C15.25 12.254 12.004 15.5 8 15.5C3.996 15.5 0.75 12.254 0.75 8.25C0.75 7.18 0.982 6.164 1.398 5.25"
          stroke="#ADACA8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 9.25C8.55228 9.25 9 8.80228 9 8.25C9 7.69772 8.55228 7.25 8 7.25C7.44772 7.25 7 7.69772 7 8.25C7 8.80228 7.44772 9.25 8 9.25Z"
          fill="#ADACA8"
          stroke="#ADACA8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29281 7.54281L2.88281 3.13281"
          stroke="#ADACA8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

export default TimerIcon
